import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Player, BigPlayButton, ControlBar, ReplayControl, ForwardControl, VolumeMenuButton   } from 'video-react';

const VideoPreview = memo(({ src }) => (
  <div className="u_relative">
          <Player
              fluid={false}
              width='100%'
              playsInline
              preload="auto"
              src={src}
              // aspectRatio="16:9"
          >
              <ControlBar>
                  <ReplayControl seconds={10} order={1.1} />
                  <ForwardControl seconds={10} order={1.2} />
                  <VolumeMenuButton vertical />
              </ControlBar>
              <BigPlayButton position="center" />
          </Player>
      </div>
));

VideoPreview.propTypes = {
  src: PropTypes.string.isRequired
};

export default VideoPreview; 